import styles from './IconGridLayout.module.scss';

import React from 'react';

import { Grid } from 'components/Grid/Grid';
import type { AppType } from 'services/cms/typesUtil';
import { IconCard } from '../IconCard/IconCard';
import { ICON_GRID_LAYOUT_TEST_ID } from './IconGridLayout.const';

type IconGridLayoutProps = AppType.Component<{
  items: AppType.Content[];
}>;

export const IconGridLayout: React.FC<IconGridLayoutProps> = ({ items }) => {
  return (
    <Grid
      container
      justifyContent="center"
      className={styles.container}
      data-testid={ICON_GRID_LAYOUT_TEST_ID.layout}
    >
      {items &&
        items.map(item => (
          <Grid item key={item?._sys?.id} lg={5} md={9} sm={12} className={styles.containerGridStyle}>
            <IconCard item={item} />
          </Grid>
        ))}
    </Grid>
  );
};
